module.exports = __webpack_public_path__ + "img/SBD.a15ec243.svg";